// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.glazik_glazikModal__xXT8D {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  z-index: 5000;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer; }

.glazik_image_container__7ezgU {
  position: relative;
  max-width: max-content;
  width: 90%;
  max-height: 90vh; }
  .glazik_image_container__7ezgU .glazik_img__2wZg7 {
    height: 100%;
    width: 100%;
    object-fit: contain;
    object-position: top left; }

.glazik_oldCoord__-GW11 {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 20px;
  height: 20px;
  cursor: pointer;
  background: rgba(33, 33, 33, 0.6);
  border: 1px solid #666666;
  color: #ffffff;
  font-weight: 400;
  font-size: 8px;
  line-height: 9px;
  overflow: hidden;
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000; }

.glazik_camera__1DEcv {
  position: absolute;
  left: 20px;
  bottom: 15px;
  font-weight: 600;
  font-size: 32px;
  line-height: 150%;
  color: #ffffff;
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000; }

.glazik_close__2SFto {
  position: absolute;
  top: 0px;
  right: -45px;
  padding: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(33, 33, 33, 0.87);
  border-radius: 50%;
  opacity: 0.7;
  transition: all 0.4s ease-in-out;
  cursor: pointer; }
  .glazik_close__2SFto:hover {
    opacity: 1; }
`, "",{"version":3,"sources":["webpack://./src/pages/inventory/components/glazik/glazik.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,MAAM;EACN,OAAO;EACP,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe,EAAA;;AAGjB;EACE,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,gBAAgB,EAAA;EAJlB;IAMI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,yBAAyB,EAAA;;AAI7B;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,+EAA+E,EAAA;;AAIjF;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,+EAA+E,EAAA;;AAGjF;EACI,kBAAkB;EAClB,QAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,kBAAkB;EAClB,YAAY;EACZ,gCAAgC;EAChC,eAAe,EAAA;EAZnB;IAcM,UAAU,EAAA","sourcesContent":[".glazikModal {\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.5);\n  top: 0;\n  left: 0;\n  z-index: 5000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.image_container {\n  position: relative;\n  max-width: max-content;\n  width: 90%;\n  max-height: 90vh;\n  .img {\n    height: 100%;\n    width: 100%;\n    object-fit: contain;\n    object-position: top left;\n  }\n}\n\n.oldCoord {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  background: rgba(33, 33, 33, 0.6);\n  border: 1px solid #666666;\n  color: #ffffff;\n  font-weight: 400;\n  font-size: 8px;\n  line-height: 9px;\n  overflow: hidden;\n  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;\n\n}\n\n.camera {\n  position: absolute;\n  left: 20px;\n  bottom: 15px;\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n  color: #ffffff;\n  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;\n}\n\n.close{\n    position: absolute;\n    top:0px;\n    right: -45px;\n    padding: 11px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(33, 33, 33, 0.87);\n    border-radius: 50%;\n    opacity: 0.7;\n    transition: all 0.4s ease-in-out;\n    cursor: pointer;\n    &:hover{\n      opacity: 1;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"glazikModal": `glazik_glazikModal__xXT8D`,
	"image_container": `glazik_image_container__7ezgU`,
	"img": `glazik_img__2wZg7`,
	"oldCoord": `glazik_oldCoord__-GW11`,
	"camera": `glazik_camera__1DEcv`,
	"close": `glazik_close__2SFto`
};
export default ___CSS_LOADER_EXPORT___;
